<template>
  <ul class="flex flex-col">
    <li
      v-for="reviewSection in reviewSections"
      :key="reviewSection.title"
      class="first:border-t-0 border-t-1 border-solid border-grey-divider-subdued first:pt-0 py-24"
    >
      <div class="flex justify-between">
        <h2 class="text-strong-body">{{ reviewSection.title }}</h2>
        <router-link
          v-if="reviewSection.editPath"
          class="text-primary link-primary font-semibold uppercase"
          :to="{
            path: reviewSection.editPath,
            query: { mode: 'edit', returnPath: $route.path },
          }"
          :aria-label="`Edit ${reviewSection.title}`"
        >
          Edit
        </router-link>
      </div>
      <p v-if="reviewSection.content" class="text-body mt-12">{{ reviewSection.content }}</p>
      <component :is="reviewSection.component" v-if="reviewSection.component" v-bind="reviewSection.props" />
    </li>
  </ul>
</template>

<script lang="ts">
import { ReviewSection } from './types';

export default {
  name: 'RouteStepperReview',
  props: {
    reviewSections: {
      type: Array as () => ReviewSection[],
      required: true,
      validator(reviewSections: ReviewSection[]) {
        return reviewSections.every((reviewSection) => {
          if (!reviewSection.title || !reviewSection.editPath) {
            console.error(`Step missing 'title' or 'editPath': ${JSON.stringify(reviewSection)}`);
            return false;
          }
          return true;
        });
      },
    },
  },
};
</script>
